export enum BannerStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export type BannerIndexInputModel = {
  code: string;
  index: number;
}

export type DroppableModel = {
  droppableId: string;
  index: number;
}

export type BannerInputModel = {
  id: string | null;
  languageId: string;
  title: string;
  description: string | null;
  textColor: string | null;
  image: string | null;
  imageAlt: string | null;
  imageForResponsive:	string | null;
  imageAltForResponsive:	string | null;
  position:	string | null;
  status:	string | null;
  validFrom:	string | null;
  validTo:	string | null;
}

export type BannerOutputModel = {
  id: string;
  languageId: string;
  title: string;
  status: string;
  code: string;
  index: number;
  shortDescription: string;
  textColor: string;
  image: string;
  imageAlt: string | null;
  imageForResponsive: string;
  imageAltForResponsive: string | null;
  position: string;
  validFrom: string | null;
  validTo: string | null;
};